import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import SearchShops from './SearchShops';
import { useLoggedIn } from '../hooks/use.logged.in';
import client from '../clients/client';

type HomeProps = {};

const Home: FC<HomeProps> = () => {
  const navigate = useNavigate();
  useLoggedIn();

  const signOut = async () => {
    await client.post('/logout');
    window.location.href = '/login';
  };

  // s-page's own action slots render in a window-wide toolbar and drop extra
  // secondary actions, so the header lives in the content column instead.
  return (
    <s-page>
      <Header>
        <Title>Shops</Title>
        <Actions>
          <s-button variant='tertiary' onClick={signOut}>Sign out</s-button>
          <s-button onClick={() => navigate('/audit')}>Audit log</s-button>
          <s-button onClick={() => navigate('/coupon')}>Coupons</s-button>
          <s-button variant='primary' icon='plus' onClick={() => navigate('/newshop')}>New shop</s-button>
        </Actions>
      </Header>
      <SearchShops embedded autoFocus />
    </s-page>
  );
};

export default Home;

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 24px 0 16px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 650;
  line-height: 28px;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;
